import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeEvery } from 'redux-saga/effects';

import { fromDto as countryFromDto } from '../../../models/adapters/CountryAdapter';
import Country from '../../../models/interfaces/Country';
import { waitBeforeFetch } from '../../../utils/FetchState';
import FetchPayload from '../../actions/FetchPayload';
import { countriesFetched, CountriesFetchedPayload, countriesFetchFailed, fetchCountries } from '../../actions/place/fetchCountries';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* fetchCountriesSaga({ payload }: Action<FetchPayload>) {
  const timestamp = moment();
  const token = yield getAuthenticationToken();
  const { fetchState } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getCountries, token, {});
  const { countries: countryDtos, error } = response;
  if (!error) {
    const countries: Country[] = countryDtos.map((country) => countryFromDto(country));
    const responsePayload: CountriesFetchedPayload = {
      countries,
      timestamp,
    };
    const responseAction = countriesFetched(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = countriesFetchFailed({ timestamp });
    yield put(responseAction);
  }
}

export default function* watchFetchCountriesSaga() {
  yield takeEvery(fetchCountries, fetchCountriesSaga);
}
